import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './components/Home';
import NotFound from './components/NotFound';
import About from './components/About';
import Header from './components/Header';
import Footer from './components/Footer';
import './css/HomeMediaQuery.css';
import Technologies from './components/Technologies';
import ContactUsMain from './components/ContactUsMain';
import BrandingStrategy from './components/Services/BrandingStrategy';
import BrandPositioning from './components/Services/BrandPositioning';
import LogoVisual from './components/Services/LogoVisual';
import PackageDesign from './components/Services/PackageDesign';
import Advertising from './components/Services/Advertising';
import Seo from './components/Services/Seo';
import SMM from './components/Services/SMM';
import Analytics from './components/Services/Analytics';
import LogoQuestions from './components/Services/LogoQuestions';
import PaidAdvertising from './components/Services/PaidAdvertising';
import EmailMarketing from './components/Services/EmailMarketing';
import UIUXDesign from './components/Services/UIUXDesign';
import MobileApp from './components/Services/MobileApp';
import Ecommerce from './components/Services/Ecommerce';
import ContentCreation from './components/Services/ContentCreation';
import Podcast from './components/Services/Podcast';
import DigitalMarketing from './components/Services/DigitalMarketing';
import WebAppDevelopment from './components/Services/WebAppDevelopment';
import { NavigationProvider } from './components/NavigationContext';
import GreenScreen from './components/Services/GreenScreen';
import VideoProduction from './components/Services/VideoProduction';
import Photoshoot from './components/Services/Photoshoot';
import Blog from './components/Blog';
import HealthCare from './components/HealthCare';
import ThankYou from './components/thankyou';
import ClientsPage from './components/ClientsPage';
import RealEstate from './components/RealEstate';
import CaseStudy from './components/CaseStudy';
import MagnAidCaseStudyDetails from './components/MagnaidCaseStudyDetails';
import EkamCaseStudyDetails from './components/EkamCaseStudyDetails';
import TwentyCaseStudyDetails from './components/22yardsCaseStudyDetails';
import EndulaCaseStudyDetails from './components/EndulCaseStudyDetails';
import LivvonCaseStudyDetails from './components/LivvonCaseStudyDetails';
// import Portfolio from './components/portfolio';
// import FoodBakery from './components/foodBakery';
// import CockTail from './components/CockTail';
// import VdoPortfolio from './components/VdoPortfolio';
// import ProductPortfolio from './components/ProductPortfolio';
// import JewelPortfolio from './components/JewelPortfolio';
// import PhotShootPortfolio from './components/PhotoShootPortfolio';
import HeadDigitalCaseStudy from './components/HeadDigitalCaseStudy';
// import EndulaWebDesign from './components/EndulaWebDesign';
// import ConceivaWebDesign from './components/ConceivaWebDesign';
// import CdcCenter from './components/Cdc';
// import MagnaidWebDesign from './components/MagnaidWebDesign';
// import LivvonWebDesign from './components/LivvonWebDesign';
// import AImarketing from './components/Services/AImarketing';
import EducationService from './components/EducationService';

const RedirectToLowercase = () => {
  const location = useLocation();
  useEffect(() => {
    const pathname = location.pathname;
    // Check if the pathname contains any uppercase letters
    if (/[A-Z]/.test(pathname)) {
      // Redirect to the lowercase version, preserving query strings
      const lowercasePath = pathname.toLowerCase();
      window.location.replace(`${lowercasePath}${location.search}`);
    }
  }, [location]);

  return null; // This component doesn't render anything
};

const App = () => {
  return (
    <Router>
      <NavigationProvider>
        <Header />
        <RedirectToLowercase /> {/* Add the redirect logic here */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path='/clients' element={<ClientsPage />} />
          <Route path="/technologies" element={<Technologies />} />
          <Route path="/contactus" element={<ContactUsMain />} />
          <Route path="/blog" element={<Blog />} />

          <Route path="/hospital-digital-marketing" element={<HealthCare />} />
          <Route path="/real-estate-digital-marketing" element={<RealEstate />} />
          <Route path="/education-digital-marketing" element={<EducationService />} />

          {/* <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/3d" element={<FoodBakery />} /> */}
          {/* <Route path="/portfolio/graphics" element={<CockTail />} /> */}
          {/* <Route path="/portfolio/video-portfolio" element={<VdoPortfolio />} />
          <Route path='/portfolio/products' element={<ProductPortfolio />} />
          <Route path="/portfolio/motion-graphics" element={<JewelPortfolio />} />
          <Route path="/portfolio/people" element={<PhotShootPortfolio />} /> */}

          <Route path='/case-studies' element={<CaseStudy />} />
          <Route path="/case-studies/magnaid-hospitals" element={<MagnAidCaseStudyDetails />} />
          <Route path="/case-studies/ekam-fertility" element={<EkamCaseStudyDetails />} />
          <Route path="/case-studies/22-yards" element={<TwentyCaseStudyDetails />} />
          <Route path="/case-studies/endula-infra" element={<EndulaCaseStudyDetails />} />
          <Route path="/case-studies/livvon-comforts" element={<LivvonCaseStudyDetails />} />
          <Route path="/case-studies/head-digitals-wroks" element={<HeadDigitalCaseStudy />} />
          {/* <Route path="/case-studies/web-designing/endula-infra" element={<EndulaWebDesign />} />
          <Route path="/case-studies/web-designing/conceiva-fertility" element={<ConceivaWebDesign />} />
          <Route path="/case-studies/web-designing/citrus-diagnostic-center" element={<CdcCenter />} />
          <Route path="/case-studies/web-designing/magnaid-hospitals" element={<MagnaidWebDesign />} />
          <Route path="/case-studies/web-designing/livon-techno-foams" element={<LivvonWebDesign />} /> */}

          {/* Lowercased if uncommented */}
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="*" element={<NotFound />} /> {/* Fixed: Use element instead of component */}
          {/* Services Routes */}
          <Route path="/branding-and-marketing" element={<BrandingStrategy />} />
          <Route path="/brand-positioning" element={<BrandPositioning />} />
          <Route path="/logo-designing" element={<LogoVisual />} />
          <Route path="/logo-question" element={<LogoQuestions />} />
          <Route path="/brand-and-packaging-design" element={<PackageDesign />} />
          <Route path="/marketing-and-advertising" element={<Advertising />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/search-engine-optmization-marketing" element={<Seo />} /> {/* Typo: "optmization" should be "optimization" */}
          <Route path="/social-media-marketing" element={<SMM />} />
          <Route path="/google-analytics-search-console" element={<Analytics />} />
          <Route path="/ppc-advertising" element={<PaidAdvertising />} />
          <Route path="/email-marketing" element={<EmailMarketing />} />
          <Route path="/website-development" element={<WebAppDevelopment />} />
          <Route path="/ui-ux-design-development" element={<UIUXDesign />} />
          <Route path="/mobile-application-development" element={<MobileApp />} />
          <Route path="/e-commerce-web-development" element={<Ecommerce />} />
          <Route path="/content-creation-and-marketing" element={<ContentCreation />} />
          <Route path="/podcast-editing-hosting" element={<Podcast />} />
          <Route path="/green-screen-studio-rent" element={<GreenScreen />} />
          <Route path="/video-production" element={<VideoProduction />} />
          <Route path="/professional-photoshoot" element={<Photoshoot />} />

          {/* <Route path="/ai-powered-marketing" element={<AImarketing />} /> */}
        </Routes>
        <Footer />
      </NavigationProvider>
    </Router>
  );
};

export default App;